
import Vue from 'vue'
import DataTableCell from './DataTableCell.vue'

export default Vue.extend({
   name: 'SelectTable',
   props: {
      selectedProperty: { type: String, default: 'IsSelected' },
      data: Array,
      headers: Array as () => NameValuePair[],
      loading: { type: Boolean, default: false },
      showSelectAll: { type: Boolean, default: false },
   },
   data() {
      return {
         selectAll: false,
      }
   },
   watch: {
      selectAll(newValue) {
         this.data.forEach((i: any) => {
            i.IsSelected = newValue
         })
      },
   },
   components: { DataTableCell },
})
